import React from "react";
import { makeStyles, Typography } from "@material-ui/core";
import { alpha } from "@material-ui/core/styles";

import I18nText from "../../../elements/I18nText";

const useStyles = makeStyles(theme => ({
  statusText: {
    fontSize: "0.75rem",
    borderRadius: 6,
    fontWeight: "bold",
    padding: "4px 8px"
  },
  green: {
    backgroundColor: alpha(theme.custom.colors.maintenanceStatus.green, 0.1),
    color: theme.custom.colors.maintenanceStatus.green
  },
  yellow: {
    backgroundColor: alpha(theme.custom.colors.maintenanceStatus.yellow, 0.1),
    color: theme.custom.colors.maintenanceStatus.yellow
  },
  red: {
    backgroundColor: alpha(theme.custom.colors.maintenanceStatus.red, 0.1),
    color: theme.custom.colors.maintenanceStatus.red
  }
}));

const MaintenanceIndicator = ({ status }) => {
  const classes = useStyles();

  return (
    <Typography
      className={`${classes.statusText} ${classes[status]}`}
      component="span"
      noWrap
    >
      <I18nText>{`devices.maintenance.trafficLight.${status}`}</I18nText>
    </Typography>
  );
};

export default MaintenanceIndicator;
